export default {
      id: "event-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#event",
      toString: function () {
        return this.url;
      }
    }